import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  useTheme,
} from "@mui/material";

export const PieChart_Conclude = ({ summarySolved = [], datalabels }) => {
  const theme = useTheme();
  const [devices, setDevices] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    const setLocalAgentState = () => {
      if (summarySolved[0]) {
        setDevices([
          {
            title: "Chat Ended",
            value: summarySolved[0].EndChat,
            color: "#BA68C8",
          },
          {
            title: "Result Saved",
            value: summarySolved[0].AssignmentChat,
            color: "#FF9800",
          },
          {
            title: "Ticket Created",
            value: summarySolved[0].TicketChat,
            color: "#4CAF50",
          },
          {
            title: "Auto End",
            value: summarySolved[0].AutoEnd,
            color: "#3F80FF",
          },
        ]);
      }
    };
    setLocalAgentState();
  }, [summarySolved]);

  useEffect(() => {
    if (devices)
      setData({
        datasets: [
          {
            data: devices.map((x) => x.value),
            backgroundColor: devices.map((x) => x.color),
            borderWidth: 1,
            borderColor: "#FFFFFF",
            hoverBorderColor: "#FFFFFF",
            datalabels: {
              anchor: "center",
              align: "center",
            },
          },
        ],
        labels: devices.map((x) => x.title),
      });
  }, [devices]);

  let final = summarySolved.map((a) =>
    Object.values(a).reduce((b, c) => b + (typeof c === "number" ? c : 0))
  );
  const options = {
    layout: { padding: 0 },
    legend: {
      display: false,
    },
    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      backgroundColor: theme.palette.background.paper,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: "index",
      titleFontColor: theme.palette.text.primary,
    },
    plugins: {
      datalabels: {
        ...datalabels,
      },
    },
  };

  return (
    <div
      style={{
        height: 380,
        paddingTop: 10,
        position: "relative",
        paddingBottom: 10,
      }}
    >
      {final[0] === 0 ? (
        <div className="DoughnutNoActivity">No Activity</div>
      ) : data ? (
        <Pie data={data} options={options} />
      ) : (
        ""
      )}
    </div>
  );
};
export default PieChart_Conclude;
